export const langEn = {
  title: 'Welcome {{name}} to KhunThong v3.0.1',
  // description: {
  //   part1: '#kuntong',
  //   part2: '',
  // },
  common: {
    bahtSymbol: '฿',
    baht: 'Baht',
  },
  date: {
    sunday: 'Sunday',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
  },
  message: {
    formValidateMsg: {
      isRequired: 'Please fill in information.',
      //isMax: 'Input amount must not be more than the suggested amount.',
      //isMin: 'Input amount must not be less than the suggested amount.',
      isNotEmailFormat: 'Invalid email',
      //isNumber: 'Incorrect number',
      isInvalidPassword: 'Password requires at least 8 characters.',
      isIdCard: 'Please fill in your 13-digit ID number.',
      isPhone: 'Mobile phone no. must contain 10 digits.',
      isPwdNotMatch: 'Password does not match!',
      isMemberEmpty: 'Please select friends.',
      //isMemberEmptyNotAllow: 'Require at least 1 person!',
      priceLessThanOrEqualZero: 'Some items have a negative value!',
      itemNameRequired: 'Please complete your items and prices in this step!',
      billNameIsRequired: 'Bill title is required!',
      billImageIsRequired: 'Image is required!',
      billTotalIsOverLimit: 'Total must not be more than {{limit}} ',
      billTotalIsLessThanZero: 'Total must be more than 0, please try again.',
      billMustHaveItem: 'Require at least 1 item!',
      wrongIdCard: 'ID Card was wrong.',
      transferAmountIsOverLimit:
        'Transfer amount must not be more than {{limit}} ',
      isDummyEmpty: 'Please select who they came with',
    },
    responseMsg: {
      //saveSuccess: 'Saved',
      saveFailed: 'Failed to save changes!',
      saveFailedReason: 'Failed to save changes, due to…',
      loadFailed: 'Error! Please try again.',
      loadImageFailed: 'Unable to load image.',
      ownerMismatch: 'Sorry! Unable to proceed, this request is not yours.',
      userMismatch: 'Oops! Unable to proceed, you are not in this request. ',
      selectAccount: 'Please select a payment method',
      duplicateBill: 'This request has been created.',
      billCanceled: 'Sorry! This request is canceled.',
      billCanceledPopup: 'Sorry!<br/>This request is canceled.',
      billNotComplete: 'The current request has not been completed yet.',
      maxBillsInGroup:
        'KhunThong can’t create bill anymore. Your group has reached the limit of {{maxBillsInGroup}} bills. Please pay your friend back before further request.',
      loadSlipFailed: 'Error! Unable to download slip, please try again.',
      requestNotCompleted:
        'The current request has not been completed yet, please try again.',
      internalServerError: 'Oops! An error occurred, please try again.',
      permissionDenied: 'Permission denied',
      notSupportBrowser: 'Sorry, please open in LINE mobile application',
      scheduleDuplicate: 'This scheduled request has already been created...',
      scheduleOwnerMismatch:
        'Sorryyy...unable to proceed. You’re not the creator of this scheduled bill',
      update_line: 'Please update your LINE version',
      location_denied:
        'Unable to locate your location. Please allow LINE access to your location.',
      pleaseAddKhunthong: 'Please add KhunThong as your friend.',
      verifyingLineAccount: '...Verifying LINE Account...',
      pleaseReopenThisWindow: '...Please re-open this window...',
      pleaseSwapInternet:
        'Connection error! Please turn off Wifi or switch cellular network and retry.',
    },
    confirmMsg: {
      //title: 'Confirm',
      //deleteItem: 'Are you sure you want to delete this item?',
      billCanceled: 'Are you sure you want to cancel this request?',
      //billCreated: 'Are you sure you want to create this request?',
      continueDo: 'Are you sure you want to confirm this request?',
      //confirm: 'Are you sure you want to {{text}} this request?',
    },
    common: {
      //billName: 'Request ',
      deleteLimit: 'Unable to delete. Must contain at least 1 item.',
      deleteUnable: 'Unable to delete.',
      //noItem: 'Could not find this item.',
      //next: 'Next',
      select: 'Select',
      confirm: 'Confirm',
      confirmYes: 'Yes',
      copy: 'Copy',
      copy2: 'Copy',
      copySuccess: 'Copied!',
      copySuccessDesc:
        'Please make sure all your information is correct before proceeding with the transaction.',
      sentSlip: 'Slip has been sent successfully!',
      currency: 'Baht',
      save: 'Save',
      cancel: 'Cancel',
      btnYes: 'Yes',
      btnNo: 'No',
      btnOkay: 'OK',
      btnLinkAccount: 'Link Account',
      btnConfirmDelete: 'Confirm',
      btnBack: 'Back',
      close: 'Close',
    },
    Remark: {
      actualTotal:
        'Total amount has been changed from {{total}}, to split equally.',
      changedTotal:
        'Total amount has been changed to {{total}}, to split equally.',
    },
    error: {
      duplicateMobileNo:
        '<b>Oops! This mobile no.<br/>has been registered.</b><br/><br/>Please unlink previous LINE Account from this K PLUS account or contact<br/>02-888-8888 (800)',
    },
  },
  cropImage: {
    cropButton: 'Crop your items',
    textLoader: 'Crop image to select items to split',
    textLoader2: 'Excluded tax, vat, discount in this step,',
    textLoader3: 'there will be input for these values next step.',
    error: {
      canReadSomeItem:
        "<b>Please verify items.~</b><br/>KhunThong's not an expert at reading yet.",
      cannotReadItem:
        '<b>Sorry! KhunThong could not read the items.</b>~<br/>Please input items manually.',
    },
    cropBtn: 'Crop Again',
    manualBtn: 'Manual Input',
    //nextBtn: 'Next',
    okayBtn: 'Okay',
    stickyContent: {
      selectImage: 'Upload Receipt',
      cropAnotherImage: 'Upload Another',
      rotateImage: 'Rotate',
    },
    uploadReceiptImage: 'Upload Receipt',
    pleaseClickUploadReceipt: 'Click "Upload Receipt"',
  },
  cropImageTutorial: {
    title: 'Crop image to select items to split',
    subtitle: 'Excluded tax, vat, discount in this step,',
    subtitle2: 'there will be input for these values next step.',
    btnOk: 'Got it!',
  },
  testcahce: {
    title: '',
    pleaseSelectBank: 'Please select a bank',
  },
  addBankAccountPage: {
    title: "Recipient's Account",
    promptPayCode: 'PromptPay No.',
    selectBank: 'Bank Account',
    accountNo: 'Account No.',
    accountName: 'Account Name',
    bankAccount: 'Bank A/C',
    promptPay: 'PromptPay',
    nextBtn: 'Next',
    confirmButton: 'Confirm',
    linkAccountDialogTitle:
      'You already have an account linked with KhunThong. Would you like to use it?',
    useAnotherAccount: 'Cancel',
    linkAccKplus: 'Confirm',
    pleaseSelectBank: 'Please select a bank',
    error: {
      followTag: 'Tell @{{displayName}} to provide receiving account number',
      accountWrong: 'This account number is invalid.',
      bankWrong: 'Please select bank',
      requireBankName: 'Please fill in account name.',
      requireBankNo: 'Please fill in account number.',
      requirePromptpayName: 'Please fill in account name.',
      requirePromptpayNo: 'Please fill in PromptPay Phone No. or Citizen ID',
      wrongIdCard: 'Invalid ID number.',
    },
    warning: {
      //fillAccount: "Please provide the recipient's account",
      fillBankCode: 'Please select bank',
    },
    placeholder: {
      specificAccount: 'Mobile Phone No./Citizen ID',
      fillAccountNo: 'Account Number',
      fillAccountName: 'Account Name',
    },
    exposedInfoWhenTransfer:
      'This information will be visible to your friends once you complete the transfer.',
    kasikornbank: 'Kasikorn Bank',
  },
  confirmAddAccountPage: {
    title: "{{name}}'s account",
    promptpay: 'Promptpay',
    warningMsg:
      'Please verify your information before saving this as the receiving account.',
    check: 'I accept terms and conditions of the service.',
    seemore: 'More details',
  },
  createBillPage: {
    account: "Recipient's account:",
    addAccount: 'Add bank account or promptpay',
    addItem: 'Add items',
    warning: 'Please select your receiving account',
    warningButton: 'Add Account',
    erorMsg: 'Incorrect information!',
    billTotal: 'Total amount',
    billName: 'Insert Title',
    promptpay: 'Promptpay',
    memberListHeader: 'Amount Per Person',
    nextButton: 'Send Request',
    nextPageTitle: 'Who owes you',
    deleteItem: 'Are you sure you want to delete this item?',
    isMemberEmptyNotAllow: 'Requires at least 1 person!',
    MemberGreaterThanBillNotAllow: 'Sorry! The amount is over the bill total.',
    notAllowDot: '. is not allowed',
    slipImage: 'Receipt',

    vatServiceChargeDiscountTitle: 'VAT / Service Charge / Discount',
    addVatServiceChargeDiscount: '+ Add',
    serviceCharge: 'Service Charge',
    vat: 'VAT',
    discount: 'Discount',
    delelteParentDummy:
      'Removing this member will remove the person who came with @{{name}}. Confirm if you want to proceed.',

    placeholderFood: 'e.g., item 1',
    placeholderWater: 'e.g., item 2',
    placeholderDrink: 'e.g., item 3',
    placeholderOther: 'Add item',
    alreadyHaveOneBillDoYouWantMore:
      'Someone has created bill in this group. Would you like to create another bill?',
    createMoreBill: 'Create Another',
  },
  randomBillName: {
    morning: {
      morning1: 'Our breakfast!',
      morning2: 'Brekkie bill right here!',
      morning3: 'Morning reminder',
    },
    afternoon: {
      afternoon1: 'Your lunch share!',
      afternoon2: 'From lunchtime',
      afternoon3: 'Lunch from earlier!',
    },
    evening: {
      evening1: 'Your dinner share!',
      evening2: 'Remember this meal?',
      evening3: 'Your evening meal',
    },
    general: {
      general1: 'Ready to pay?',
      general2: 'Ready to collect',
      general3: 'Don’t forget to pay!',
      general4: 'KhunThong is here!',
      general5: 'Pay heree, pls~',
    },
  },
  accountManagementPage: {
    mainButton: 'Save',
    manageAccount: 'Manage Account',
    kPlusAccount: {
      addAccountByKPLUS: 'Link KBank Account',
      kplusRemark: 'Only with K PLUS App',
      paymentAccount: 'Payment Account',
      cancelAccountBinding: 'Unlink Bank Account',
      accountName: 'Account Name',
      number: 'Number',
    },
    recipientAccount: {
      addAccount: 'Add Account',
      addAccountRemark: 'Easy and Compatible with Any Bank',
      recipientAccount: 'Recipient Account',
      accountName: 'Account Name',
      number: 'Number',
    },
    accountSetting: {
      setting: 'Settings',
      termAndCondition: 'Terms & Conditions',
      PDPA: 'Data Privacy Policies',
    },
  },
  inviteFriendPage: {
    nextBtn: 'Split',
    mainBtn: 'Next',
    title: 'Who owes you?',
    search: 'Search',
    allmember: 'Everyone',
    addMoreFriend: 'Add Outside Members',
    save: 'Save',
  },
  billAssignPage: {
    title: 'Select / Assign Items',
    selectAllMember: 'Select All Members ({{length}})',
    friendNotSelect:
      'Unassigned members ({{nonSelectLength}}/{{memberLength}})',
    billSummary: 'Finalize',
    save: 'Save',
    warning: {
      alreadySummary:
        'Sorry! KhunThong sent this request to the group. <br/>Go to Payment Status',
      alreadyClose: 'This bill has been closed. <br/>Go to Payment Status',
      pleaseSelectMember: 'Please Select Members',
      friendNotSelect:
        'Oh No! {{remainMember}} friend(s) left unassigned<br/>Please finish assigning items first.',
      orderNotSelect:
        'Oh No! {{remainItem}} item(s) left unassigned<br/>Please finish assigning them first.',
      vatNoMember:
        'Oh No! {{items}} still left unassigned. Please finish assigning them first.',
      cannotBackToEdit:
        "Sorry! This bill has been created,\nyou can't change the request.",
      onlyOwnerCanSummarize: 'Only bill creator @{{ownerName}} can finalize.',
      willDeleteDummies:
        'When you delete @{{parentName}}, it will also delete {{dummiesName}}',
      willDeleteMember: 'Do you want to delete @{{name}} ?',
    },
    splitEvenly: 'Split Evenly',
    splitProportionately: 'Split Proportionately',
    edit: 'Edit',
    dialogEditItems: {
      saveItems: 'Save',
      edit: 'Edit',
      save: 'Save',
      itemUnnamed: 'Oops! Some items are blanked, please complete all fields',
      itemNoPrice:
        'Oops! Some items are missing price, please complete all fields',
    },
    addPerson: 'Add Members',
    calculateBill: 'คิดเงิน',
  },
  payTypePage: {
    billCancle: 'This bill has been cancelled!',
    billOwner: "You're the requester.\r\nNo need to pay.",
    paySuccess:
      'You\'ve successfully paid for "{{billName}}"<br/>{{amount}} THB to {{ownerName}} {{extendMessage}}',
    waitForConfirm: '<br/>( Waiting for confirmation from receiver. )',
    //transfer: 'Transfer to',
    //accountNo: 'Account No.:',
    promptpay: 'Promptpay',
    selectMethod: 'Select Payment Method',
    paymentOption: {
      kplusLink: 'Transfer with K PLUS',
      kplus: 'KBank {{accountNo}}',
      kplusAdd: 'Link with KBank Account',
      slip: 'Verify Payment with e-Slip',
      cash: 'Mark as Paid',
    },
    warningKplus: 'Powered by KBank',
    kplusOtherDevice:
      'Please link your account with K PLUS again! Some information has been removed or KhunThong is being used on a new device',
    warning: {
      receiveAccChanged: {
        content1: 'Please check account information before transferring',
        content2: '@{{lineName}} just changed receiving account',
        button: 'Okay!',
      },
      payWaiting:
        'After transferring with K PLUS, please send the slip from K PLUS into the group chat.',
      payOverLimit: {
        title:
          '<b>Daily transaction limit through KhunThong is {{transferLimit}} THB.</b><br/>This amount exceeds the limit. I recommend using another transfer method. (Daily Remaining Limit is {{amount}} THB)',
        kbank: {
          button: 'Transfer with K PLUS >',
        },
        other: {
          button: 'Okay',
        },
      },
    },
    billAmountAdaptedFrom: 'Total Amount has been rounded from',
    bindedAccount: 'Linked Account',
    transferTo: 'Transfer to',
    privateBillDetail: '“{{billName}}” จาก @{{ownerName}}',
    pleasVerify: 'โปรดตรวจสอบรายละเอียดบิลก่อน ก่อนกดจ่ายเงิน',
    account: 'บัญชีรับเงิน',
    reject: 'ไม่ใช่บิลของฉัน',
    pay: 'จ่ายเงิน',
    overImageSize: '<b>น้องว่าไฟล์นี้ใหญ่ไป~</b><br/>รบกวนอัพโหลดรูปใหม่นะค้าบ',
    wrongImageType:
      '<b>น้องไม่รองรับไฟล์ประเภทนี้ค้าบ~</b><br/>รบกวนอัพโหลด e-Slip ที่มี QR น้า',
    privateBillExpire:
      'บิลนี้หมดอายุแล้วน้า<br/>หากคุณพี่จะทำรายการ...ติดต่อเจ้าของบิลเลยจ้า',
    privateBillFull:
      'บิลนี้มีผู้รอจ่ายครบแล้ว...<br/>รบกวนติดต่อเจ้าของบิลค้าบ',
    privateBillMemberNotFound:
      'บิลนี้ไม่ใช่ของพี่นะค้าบ<br/>รบกวนติดต่อเจ้าของบิล<br/>เพื่อตรวจสอบค้าบ',
    privateBillCancel: 'บิลนี้ถูกยกเลิกแล้ว<br/>รบกวนพี่ติดต่อเจ้าของบิล',
  },
  payTypeSelectedPage: {
    promptpay: 'Promptpay',
    //accountNo: 'Account Number',
    payCash: 'I already paid by cash!',
    remark: 'Please verify details, as this cannot be changed later.',
    count: 'Amount',
    fee: 'Fee',
    cashButton: 'Confirm',
    remarkSlip: 'To verify e-slip with KhunThong',
    remarkSlip1: '1. Copy Account Number OR PromptPay',
    remarkSlip2: '2. Transfer with your mobile banking app',
    remarkSlip3:
      '3. Send transfer Slip and e-Slip with QR to the groupchat or upload here',
    remarkSlipPrivateBill: 'โอนเอง แล้วอัพโหลด e-Slip',
    remarkSlipPrivateBill1: '1. คัดลอกเลขบัญชี',
    remarkSlipPrivateBill2: '2. ไปโอนผ่าน Mobile Banking ของธนาคารที่คุณใช้',
    remarkSlipPrivateBill3: '3. กลับมาอัพโหลด e-Slip เพื่อเป็นหลักฐาน',
    baht: 'Baht',
    transferTo: 'Transfer to',
    uploadButton: 'Upload e-Slip',
  },
  payTypeStore: {
    comingSoon: 'See you very soon!',
    transferToBankAccountOnly: 'Transfer to bank account only',
  },
  selectBankPage: {
    title: 'Select Bank',
    placeholder: {
      search: 'Search',
    },
  },
  billInfoPage: {
    //confirmButtonText: 'Confirm',
    cancelButtonText: 'Cancelled',
    paymentButtonText: 'Pay',
    cancelCollectButtonText: 'Cancel This Request',
    bankAccount: "Recipient's account:",
    summaryButtonText: 'Finalize',
    sendGroupButtonText: 'Send Request',
    membersAssignTitleName: 'Unpaid Member(s)',
    membersPaidTitleName: 'Paid Member(s)',
    membersWaitingTitleName: 'Waiting to Verify: Marked as Paid',
    completePay: 'Payment Completed!',
    memberListPage: {
      cash: 'Cash',
      kplus: 'K PLUS',
      khunthong: 'KhunThong',
      transfer: 'Slip',
      owner: 'Owner',
    },
    memberTotalLessThanZero:
      'Successful! Some friends still have a total that is less than or equal 0',
    billCanceled:
      '<b>Bill is incomplete!</b><br/>Are you sure you want to cancel this request?',
    cannotCancelBill: 'Sorry! This bill cannot be cancelled',
    promptpay: 'Promptpay',
    paid: 'Verify',
    nopaid: 'Reject',
    paymentTrans: {
      cash: 'Cash',
      kplus: 'Paid with Kasikorn (K PLUS) account',
      khunthong: 'Paid with Kasikorn (KhunThong)',
      transfer: 'Slip',
      //owner: 'Owner',
      channel: 'Channel',
      //amount: 'Amount',
      txnNo: 'Transaction No.',
      txnDate: 'Transaction Date',
    },
    paymentTransBottom: {
      amount: 'Amount',
      baht: 'Baht',
      remark: 'Note',
      paidMoreThanOneBill:
        'The amount in this transaction pays for {{billNumber}} bills.',
    },
    notOwner: '<b>Sorry! This bill is not yours.</b><br/>Unable to cancel.',
    paidWithCashButton: 'Check As Paid',
    selectAll: 'Select All',
    durationPrefix: 'Every',
    summaryBill: 'สรุปบิล',
  },
  paymentSuccessPage: {
    completePayResponsibility: 'Payment Completed!',
    completeKPlusPayResponsibility: 'Transfer Completed!',
    completePay: 'Payment Completed!',
    completeCashPay: 'Payment Completed!',
    completeKPlusPay: 'Transfer Completed',
    youPaid: "You've successfully paid",
    youPaidTo: 'by cash 💸',
    labelAmount: 'Amount:',
    labelRefNo: 'Ref. No',
    labelFrom: 'From',
    labelTo: 'To',
    mainBtn: 'Back to chat',
    paymentRemark: 'Transaction by Kasikorn Bank',
    saveSlipBtn: 'Share Slip',
    thb: 'THB',
    optionButton: 'See your {{number}} pending bill(s)',
    optionButtonSeeWhoPaid: 'See Who Paid',
    errorAlreadyPaid: {
      withCash: 'by cash {{isWaiting}} 💸',
      isWaiting: '( Waiting for confirmation from receiver. )',
      youPaid: "You've successfully paid “{{billName}}”",
      alreadyPaidCashFor: "You've successfully paid {{ownerName}}",
      alreadyPaidFor: 'bill to @{{ownerName}} {{payType}}',
      paidWithCashTitle: 'Payment Completed!',
      paidWithKPLUSTitle: 'Transfer Completed',
      paidWithKhunthongTitle: 'Transfer Completed',
      paidWithSlipTitle: 'Payment Completed!',
      seeDetail: 'See Details',
    },
  },
  multiplePaymentSuccessPage: {
    selectedAndWait: 'Waiting for Payment Confirmation',
    paymentSuccess: 'Payment Successful',
    waitForConfirmation:
      'Waiting for Payment Confirmation from @{{billOwnerName}}',
    overAmount: 'Exceeding Amount',
    underAmount: 'Still Owing',
    total: 'Total',
    accountNotMatchFromUploadSlip: 'Transfered to other account',
    waitForConfirmFromUploadSlip: 'Waiting for confirmation from receiver.',
    waitForConfirmationFromUploadSlip:
      'Waiting for Payment Confirmation from @{{billOwnerName}}',
  },
  verifyKPlusRegisterPage: {
    header: 'Instant & Safe Transfer with KhunThong',
    content:
      'Link K PLUS account before anyone else if you are a  KBTG employee or a registered Beta User',
    linkRegisterBetaUser: 'Register Beta User',
    remark1:
      'Note: The transaction limit, without a PIN, is {{transferLimit}} THB per day. This account can be used as your receiving account and for any transactions through KhunThong. Users can unlink their accounts through the Official Account @KhunThong LINE Chat.',
    remark2: 'Please wait for a confirmation email',
    btnNext: 'Link KBank Account',
    fastTransfer: 'Fast transfer',
    within2ClickWithoutSwapping: 'within 2 Clicks, without switching apps',
    secure: 'Secure',
    withKplusVerification: 'with self-verification through K PLUS',
    getAChance: 'Get a chance to win',
    getPromotionAnd: 'promotions and',
    manyMorePrivilege: ' other Special Privileges',
    getCashback: 'รับเงินรางวัล',
    toGetMoneyFromTheActivity: 'จากกิจกรรม #ชวนเพื่อน',
    moreConvenient: 'สะดวกกว่า',
    toUseKhunThongWithoutPin:
      'เพื่อใช้บริการขุนทองรับเงิน และโอนเงินผ่านขุนทองโดยไม่ต้องใช้ PIN',
    forUserNoKPUS: 'Don’t have K PLUS? Install here! >',
  },
  verifyKPlusPage: {
    phoneLabel: 'K PLUS Phone Number',
    phonePlaceholder: 'Fill in Phone Number',
    idCardLabel: 'Citizen ID Number',
    idCardPlaceholder: 'Fill in Citizen ID Number',
    remark:
      'Note: Please verify details as users cannot register service more than 3 times per day.',
    btnText: 'Continue with K PLUS',
    submitButton: 'Confirm',
  },
  successPage: {
    //closeButtonText: 'Close this tab',
    successText: 'The current request has been completed',
    pleaseCloseText: 'Please close this tab to continue using KhunThong',
  },
  homePage: {
    titleText: 'KhunThong',
  },
  termAndCondition: {
    title: 'Term and condition',
    contentHtml:
      '<p><span><strong>Terms and Conditions for Use of KhunThong Service</strong></span></p><p><span>The User agrees to use KhunThong Service (</span><span><strong>“KhunThong”</strong></span><span>) or any name prescribed by KASIKORNBANK Public Company Limited (the “</span><span><strong>Bank</strong></span><span>”), as the Bank deems appropriate, whereby the User agrees to be bound by and comply with the following terms and conditions (the “</span><span><strong>Terms and Conditions</strong></span><span>”).</span></p><p><span>1. In order to use KhunThong, the User shall be a LINE Messenger user of LINE Corporation Limited ("</span><span><strong>LINE Messenger</strong></span><span>") and add "</span><span><strong>KhunThong</strong></span><span>" as a friend in LINE Messenger group that wishes to use the service. KhunThong offers various services such as calculating payment of goods / services per person, and scanning the receipt for goods / services and calculating payment per person in accordance with terms, conditions, period, channels, and methods of each transaction, product, and service as specified by the Bank. Messages in appropriate and clear language shall be used for the service.</span></p><p><span>2. Regarding the use of user ID and / or password and / or One-Time Password (OTP) and / or other tools that the User applies to log in LINE Messenger ("</span><span><strong>Individual PIN</strong></span><span>") to use the service in accordance with the Terms and Conditions:</span></p><p><span>2. 1. If use of the service in accordance with the Terms and Conditions requires an Individual PIN, the User shall specify an Individual PIN in accordance with specified conditions and procedures for each channel.</span></p><p><span>2. 2. The User shall safeguard the Individual PIN and must keep it confidential. Disclosure of the Individual PIN is regarded as non-compliance with the Terms and Conditions. If there is any loss (including that caused by funds transfer transaction) arising from the disclosure of the PIN or any action that results in other people knowing of or receiving the Individual PIN, or the lost or stolen Individual PIN, the User shall be responsible for said loss before the User proceeds to suspend or cancel the use of the Individual PIN.</span></p><p><span>2. 3. The User agrees that any actions performed, including but not limited to application for and use of services, payment for goods / services, funds transfer, identity verification, approval of transactions, providing any information to the Bank, acceptance of/ amendment to terms and conditions/services/fees of services, provided by the Bank and/or any person/juristic person, regardless of whether said actions were undertaken by the User themself or by another person </span><span><strong>with the use of the Individual PIN, are complete and valid, and shall be binding upon the User as if they were undertaken by the User themself; and it shall be deemed executed by the User by way of electronic signature</strong></span><span> as evidence for the transaction, which is complete and valid from the time the transaction is confirmed. The User acknowledges the risks related to the use of electronic services which require no additional documents or evidence for confirmation and/or delivery to the Bank, unless otherwise stated by the Bank. The User shall check the balance every time a transaction has been conducted.</span></p><strong><span>3. The User who requests to be paid for goods / services (</span><span><strong>"Sender who requests payment") </strong></span><span>can ask the Bank to tag other members in the LINE Messenger group </span><span><strong>("Recipients who receive a request for making a payment"</strong></span><span>) to transfer / make a payment to the Sender by referring to details and amount of money, goods / services list, and Recipients (specified by Sender). The User accepts and agrees that services under the Terms and conditions provide preliminary calculation results only. The result correctness depends on accuracy and completeness of the given information from the Sender. The Bank’s system will show rounded-up calculation results which may not be equal to the actual total amount on the receipt. The User shall be responsible for checking the amount of money before making a payment.</span></strong><p><span>4. Recipients who receive a request for making a payment can make funds transfer/payment to the Sender who requests Payment, by:</span><span>(1) Paying directly, and/or </span><span>(2) Transferring funds via ATM, and/or</span><span>(3) Transferring funds via the Bank or other payment service providers per their terms and conditions, and/or </span><span>(4) Debiting their linked deposit account. Recipients are required to log in to K PLUS and give an approval for assigning their deposit account to be a source of funds for KhunThong by using the Fund Transfer Tool as specified in the K PLUS terms and conditions. This approval allows Recipients to conduct funds transfer/payment transaction within the limit of 1,000 Baht/day, or as specified by the Bank, without logging in to K PLUS. After the Bank has received confirmation for the details of funds transfer/payment via the linked deposit account, regardless of whether said actions were undertaken by another person, Recipients accept and agree to authorize the Bank to immediately debit the amount as specified from the linked deposit account for funds transfer/payment to the Sender who requests payment.</span><span>(5) By debiting their deposit account via K PLUS  within the limit per day that the User has set in K PLUS, per the steps determined by the Bank. </span></p><p><span>5. The User shall check the completeness and accuracy of payment / funds transfer information, including but not limited to the name-surname of the Sender who requests payment, bank name, deposit account name, and deposit account number (if any).</span></p><p><span>6. The User agrees to authorize the Bank to debit the User’s deposit account to allow the Bank to conduct transactions and/or proceed to undertake operations per the method of the Terms and Conditions, without giving notice. The Bank shall send evidence for account debit to the User.</span></p><p><span>7. The User agrees to authorize the Bank to immediately debit the User’s deposit account and or any type of deposit account held by the User at the Bank or the funds under possession, care and/or authority of the Bank, regardless of how the Bank has obtained such deposit, possession, care and/or authority for payment of debt and/or liabilities of the User, without giving notice. The Bank shall send evidence for account debit to the User.</span><span>If funds in the deposit account and/or aforesaid funds are insufficient for payment of debt and/or liabilities, the User agrees to pay the outstanding debt to the Bank in full.</span></p><p><span>8. The service does not guarantee that the Sender who requests payment shall receive funds transfer/payment from Recipients who receive a request for making a payment. It depends on whether or not such a request is received by Recipients who receive a request for making a payment, or whether or not the Recipients who receive a request for making a payment shall make funds transfer/payment, or the funds/payment may be transferred/made at any time and by any means. The Bank has no involvement regarding the information and details provided by the User. The User therefore agrees that the Bank shall have no responsibility when: (1) The data provided by the Sender who requests payment is inaccurate or incomplete; (2) The User has not opened LINE Messenger at that time, or (3) Recipients who receive a request for making a payment do not make funds transfer/payment to Sender who requests payment, either in part or in whole, or at any time; or (4) LINE Messenger or the internet system of the User which is beyond the Bank’s control is out of order, or disrupted by natural disaster, riot or any other force majeure, preventing the sending or receiving of data.</span></p><p><span>9. The User agrees to comply with laws, regulations, directives and any criteria of the Bank or banking supervision agencies and any other competent authorities (as the case may be), currently existing and/or to exist in the future (hereinafter collectively referred to as the </span><span><strong>“Relevant Laws and Regulations”</strong></span><span> unless individually stated). In case of change in the Relevant Laws and Regulations, the User agrees to comply with the Relevant Laws and Regulations so changed immediately after being notified by the Bank. If the User fails to comply therewith and non-compliance has resulted in a penalty fee, damages and/or other expenses collected from the Bank, the User agrees to be immediately responsible for payment of such penalty fee, damages and/or expenses to the Bank.</span></p><p><span>10. All financial, accounting, or any other information provided by the Bank to the User or by the User to another User shall be kept confidential, and the User shall not divulge it to others.</span></p><p><span>11. The User agrees to allow the Bank to collect and use the User’s information provided to or via the Bank or held by the Bank or that the Bank has received or obtained from other sources for the purpose of providing services to the User, undertaking operations per the User’s request prior to service provision, assigning work to another person to support the services regarding IT, communications, collection or any other tasks, transferring rights to claim, legal compliance, risk management, audit, internal management, complaint handling, and other purposes necessary for the significant operations of the Bank or to allow the Bank to continue to provide services with fairness. The User agrees to allow the Bank to disclose such information to KASIKORNBANK FINANCIAL CONGLOMERATE, external service providers, the Bank’s agents, subcontractors, co-branding partners, data processors, auditors, external inspectors, credit information companies, credit rating companies, asset management companies, prospective assignees, assignees, competent authorities, or any agencies/organizations/juristic persons having entered into a contract with the Bank. The User also agrees to authorize such recipients of information from the Bank to collect, use and disclose such information under said purposes, and send or transfer such information to keep on a server/cloud in other countries. </span><span>Other details and rights are shown in the Privacy Policy page of the Bank’s website [www.kasikornbank.com/th/privacy-policy/Pages/privacy-policy.aspx]</span></p><p><span>12. If there is an error in payment/ funds transfer which is not caused by the Bank, the User agrees to examine the error and directly claim the amount from, or reimburse the sum to, the User’s disputing party. If the User has any defense and/or rights to claim, the User shall directly and separately take an action with the disputing party.   </span></p><p><span>13. Unless the Bank has stated otherwise, if the User finds any error, or if there is any cause for temporary suspension of the operations under KhunThong, either entirely or partially, or if the suspension of the operations is to be revoked, the User may call the K-Contact Center at 02-888-8888 throughout 24 hours, or any other channels determined by the Bank. The User must provide the Bank relevant information including the date, time, related parties, the transaction amount, and its characteristics, as well as any other information that the Bank may request. After the User has completely undertaken operations per procedures determined by the Bank, the Bank shall proceed to undertake related operations including examination/correction of the error, suspension of the operations or revocation of the suspension of the operations within the period informed to the User, and the User shall remain responsible for the operations and transactions that have been conducted before the expiration of the said period. The Bank reserves the right to disregard any request which is contrary to the Relevant Laws and Regulations.</span></p><p><span>14. If the User does not use / changes / cancels / does not own the LINE Messenger account (LINE Account) that adds KhunThong, the User is responsible to inform the Bank in order to suspend the service immediately according to the Bank process. The Bank has no obligation to verify or be responsible for any damages that occur before the Bank has suspended the service. If the User does not inform the Bank of the change, the User agrees to take full responsibility for all damages incurred, to either the Bank or any person.</span></p><p><span>15. Fees/Service Charges/Expenses/Penalty Fees/Taxes and Stamp Duties </span></p><p><span>15. 1. The User agrees to pay remuneration for using the service regardless of whether it is called a fee/service charge or other name, to the Bank, within the due date for payment of respective remuneration.  </span></p><p><span>15. 2. The Applicant agrees to be solely responsible for costs, taxes, duties and/or any expenses related to services (if any). </span><span>If the Bank has to make advance payments for the costs, taxes, duties and/or any expenses mentioned in the preceding paragraph on behalf of the User, the User agrees to repay them to the Bank immediately.</span></p><p><span>16. The User hereby certifies that all of the various documents, data, and details, which are held by and/or which are delivered to the Bank, regardless of the form in which they are sent, whether by the User or any person, via Individual PIN, are complete, accurate and up-to-date. The Bank has the right to use the documents/information to provide services and update data in the Bank’s system. The User has the rights and is legally competent to request the use of services and to make transactions related to KhunThong services. </span></p><p><span>17. If the User wishes to inquire or correct information and / or any details, the User shall contact the Bank via K-Contact Center at Tel. +662-8888888.</span></p><p><span>18. Change in Conditions of Service </span></p><p><span>18. 1. If the change in conditions of service usage causes the User to incur more burden or risk, such a change shall require prior consent from the User. </span></p><p><span>18. 2. If other conditions are to be changed, the User agrees to authorize the Bank to make the change as it deems appropriate. If the change affects the User’s use of the service (such as adjustment of service fees to reflect rising costs, change to service channels, change to due date), the Bank shall expressly communicate, or give notice of, material information of the change to the User at least 30 (thirty) days in advance or within the period required by law.</span></p><p><span>18. 3. If the Bank is required by Law and/or regulations to proceed with a change in other specific conditions, the User agrees to authorize the Bank to act in compliance therewith.  </span></p><p><span>19. The Bank is entitled to suspend and/or terminate the services, whether in whole or in part, or for any particular User, at any time, with prior notice given to the User. Regarding the following incidents, the User agrees that, at the Bank’s discretion, the Bank can </span><span><strong>immediately</strong></span><span> suspend and/or terminate the services, whether in whole or in part, as KBank deems appropriate, without prior notice. The Bank will not be held responsible for any damages caused by the following:</span></p><p><span>19. 1. Any data, details, warranty or confirmation provided by the User is not true or not accurate, or may cause material misunderstanding.</span></p><p><span>19. 2. A fact comes to light that convinces the Bank that data and/or details provided by the User to the Bank for operations or the use of KhunThong services by the User may have adverse consequences, or may affect the rights of the Bank or another person, or it is suspected that the User has or will have purposes which are illegitimate or contrary to public order or morality, or there is obscene/offensive content, or there are actions deemed by the Bank as taken by, or likely to be taken by, fraudsters, or unusual operations, or they may cause the Bank to violate laws and/or regulations and/or any orders and/or cooperation and rules and regulations of the Bank and/or the Bank of Thailand and/or auditor and/or banking supervisory agencies, or may adversely affect the Bank’s image.</span></p><p><span>19. 3. The User fails to comply with one of the Terms and Conditions, including failure to make payment of fees/service charges/expenses/penalty fee/taxes and duties (if any).</span></p><p><span>19. 4. The Bank foresees situations that may impact the User‘s business operations or the User’s debt servicing ability, or the User dies, or the User terminates the business, or the User’s business license is revoked, or the User’s business is suspended or liquidated.</span></p><p><span>19. 5. The Bank cannot debit the User’s deposit account for services under the Terms and Conditions.</span></p><p><span>19. 6. The Bank has found that there is a risk of loss caused by modifications and alterations of the User’s Device, or by the systems of the mobile phones and/or any other incidents such as jailbreak (“</span><span><strong>jailbreak</strong></span><span>” meaning the modification of the iOS or operating system of the Device which changes the authorized access without the permission from the producer/operating system owner), or root (“</span><span><strong>root</strong></span><span>” meaning the change in the Android operating system of the Device, causing the change in authorized access of the users without the permission from the producer/operating system owner). This is intended to prevent damages that may be incurred to the Applicant. </span></p><p><span>19. 7. The Bank must comply with policies, rules and regulations, operational procedures, directives, laws, orders and/or requests for cooperation from a court of law or competent authorities, or banking supervisory agency.</span></p><p><span>19. 8. The Bank suspects or confirms that the situation in Item 14 has occurred, for whatever reason, and whether the Bank discovers the situation itself or has been notified by others.</span></p><p><span>20. If the User wishes to cancel the services under the Terms and Conditions, the User shall cancel the service by themself via LINE Messenger and proceed to undertake operations per the steps specified in LINE Messenger.</span></p><p><span>21. The termination of the Terms and Conditions, for whatever reason, shall not abrogate the User’s outstanding obligations thereunder until such obligations are completely fulfilled.</span></p><p><span>22. In case of force majeure or any other causes that prevent the Bank from providing the services under the Terms and Conditions, the User agrees that it shall be at the Bank’s discretion to provide the services or take any action as it deems appropriate to comply with the Terms and Conditions; the User agrees to fully cooperate with the Bank in every way to improve the service method of the Bank.</span></p><p><span>23. Any delays or exemptions in exercising rights under the law or the terms and conditions, including handbooks and the Bank’s IVR system, shall not be regarded as the Bank’s relinquishing such rights or as the Bank’s giving the User consent to perform any act.</span></p><p><span>24. Whenever any one of the items in the Terms and Conditions becomes void, illegitimate, invalid or unenforceable, the other remaining terms and conditions (as the case may be) shall remain legally valid and enforceable; they shall not be affected by voidability, illegitimacy, invalidity or unenforceability of those terms and conditions.</span></p><p><span>25. The Terms and Conditions shall be governed by and construed in accordance with the laws of the Kingdom of Thailand, and the court of Thailand shall have exclusive jurisdiction to adjudicate any dispute arising under or in connection with the Terms and Conditions.</span></p>',
    button_cancel: 'Cancel',
    button_confirm: 'Confirm',
    desc: 'Please carefully read the following Terms and Conditions',
    chkConfirm: 'I agree to the Terms and Conditions above.',
  },
  medalPage: {
    warning: {
      errorGetImage: 'Something went wrong, unable to create image.',
    },
    processingImage: 'Please wait, KhunThong is processing the image.',
    share: 'Share',
    memberList: {
      quickPrice: 'Fastest Payer!',
    },
    sharedApp: {
      hashtag: '#KhunThong',
      title: 'ขุนทอง (KhunThong)',
      description:
        'KhunThong - Chatbot Treasurer, an expert in requesting money',
      photoAlt: 'KhunThong',
      share: 'Share',
    },
  },
  donationPage: {
    donationFlexAltText: 'Sends to donation units from KhunThong',
    donationBy: '#เราจะผ่านไปด้วยกัน',
    donationRemark:
      'KhunThong would like to help promote donations to support the frontline workers COVID-19. Call KhunThong to receive donations by typing',
    hightlight: '#covid19',
    donationRemarkBy: ' (Information Supported by Kasikorn Bank)',
    donation: 'Donation Unit',
    shareButton: 'Share to Line',
    cannotShareTargetPicker:
      'Sorry! This function does not support versions below LINE 10.3.0',
    apiNotAvailable: 'Oops! Your LINE version doesn’t support this feature.',
  },
  donationDestinationInfoPage: {
    mainBtn: 'Select Donation Method',
    note: 'More Details',
    detail: 'Thank you for taking part in helping us fight against COVID 19',
    taxDeduction: 'Tax Deduction',
    selectMethod: 'Select Donation Method',
    paymentMethod: {
      kplus: 'Donate with K PLUS',
      qr: 'Donate with QR e-Donation',
    },
  },
  donationPaymentKPlusPage: {
    total: 'Total',
    remark:
      'Note: Please  verify details before donating through this platform. This is not an e-Donation system; therefore, if you would like to receive tax benefits, please bring receipt from organization to receive tax deduction.',
    nextBtn: 'Continue With K PLUS',
  },
  donationPaymentQRPage: {
    nextBtn: 'Next',
  },
  rollcallPage: {
    topic: '#RollCall',
    unanswerListTopic: 'Have Not Answered',
    answerListTopic: 'Answered',
    completeButton: 'Complete Roll Call',
  },
  rewardInfoPage: {
    duration: 'Expires',
    tabDetail: 'Details',
    tabCondition: 'Conditions',
    claimNow: 'Claim Now',
    eligibleUntil: 'Eligible Until',
  },
  campaignActivityPage: {
    activityEmpty: 'There is currently no ongoing activities.',
    couponEmpty: 'You do not have any coupons',
    activityText: 'Activity',
    couponText: 'My Coupon',
    couponListInactive: 'Used Coupons / Expired',
    couponInactive: 'Expired',
    daily: 'Today',
    monthly: 'This Month',
    weekly: 'This Week',
    normal: '',
    messageDesc: '{{remindLeft}} Coupons Left {{displayType}}',
    messageCouponDone: 'No Coupons Left',
    messageCouponNotDone: 'No Coupons Left. Next Set of Coupons on:',
    eligibleUntil: 'Eligible Until',
    myCoupon: {
      eligibleUntil: 'Eligible Until',
    },
  },
  campaignInfoPage: {
    //activity: 'Activity',
    duration: 'Duration',
    tabDetail: 'Details',
    tabCondition: 'Conditions',
    detailTopic: 'Activity Rewards',
    messageCouponLeft: '{{remindLeft}} Coupons Left {{displayType}}',
    messageCouponNotDoneWithType:
      'No Coupons Left {{displayType}} - Next Date:',
    messageCouponNotDone: 'No Coupons Left. Next Set of Coupons on:',
    messageCouponDone: 'No Coupons Left',
  },
  campaignRewardCodePage: {
    placeTheBelowCodeToProceed: 'Insert code below, when making payment.',
    eligibleUntil: 'Eligible Until',
    code: 'Code',
    qrCode: 'QR Code',
    barCode: 'Barcode',
  },
  campaignRewardMessagePage: {
    eligibleUntil: 'Eligible Until',
  },
  rewardPage: {
    headerTextRequester: 'Congratulations!!!',
    headerTextPayer: 'Your Friend Received a Gift!',
    titleRequesterTemp: 'Successful Payment Collection!',
    getRewardAlready: 'You already took part in this activity.',
    //titlePayerTemp: 'Activity: Introduce KhunThong to New Friends',
    titleExpried: 'This Campaign Has Expired',
    btnNextCoupon: 'Go to My Coupons',
    btnNextActivity: 'Take Part in Activity',
    checkNewCamp: 'Check Recent Campaigns',
  },
  imageListDialog: {
    title: 'Select Icon',
    select: 'Select',
    cancel: 'Cancel',
  },
  scheduleCreatePage: {
    title: 'Create Scheduled Bill',
    titleDescription: 'Here are my suggestions...',
    reachMaxScehdule:
      'Reach the limit. Maximum = {{maxScheduleBillsInGroup}} Schedule bills/group.',
    noBill1:
      'Reach the limit.\nMaximum = {{maxScheduleBillsInGroup}} Schedule bills/group.',
    noBill2: '',
    scheduleBill: 'Schedule Bill',
  },
  scheduleAssignPage: {
    scheduleName: 'Insert Title',
    startDate: 'Start Date',
    total: 'Total Amount Due',
    totalByTotal: 'Total',
    totalPerEach: 'Per Person',
    totalAll:
      'Total Amount Due for ({{personNo}} participant(s)) is ฿ {{total}}',
    memberHeader: 'Amount due per person ({{personNo}} participant(s))',
    memberHeaderPerEach: "Who's sharing the bill? ({{personNo}} participant(s)",

    addAccount: 'Add Account or Promptpay',
    account: "Recipient's Account:",
    promptpay: 'Promptpay',

    btnSave: 'Save',
    memberEmptyNotAllow: 'There must be at least 1 member.',
    accountEmptyNotAllow: 'You have not chosen a receiving account.',
    btnAddAccount: 'Add Account',
    errorMsg: 'Some information is incorrect.',

    memberList: {
      collectingInterval: 'Recurrence Frequency: Every',
    },
  },
  scheduleSummaryPage: {
    //billCanceled:
    //  '<b>This bill has not been completed.</b><br/>Are you sure you want to cancel?',
    billCanceledFromFlex:
      '<b>Scheduled Payment Bill</b><br/>Are you sure you want to cancel?',
    billEdited:
      '<b>Warning</b><br/>The change will be applied to the next scheduled bill.<br/>Those who have already paid will be requested again.',
    btnEditBillOkay: 'Edit',
    billTypeM1: 'Month(s)',
    billTypeW1: 'Week(s)',
    billTypeWeek: '{{number}} Week(s)',
    billTypeMonth: '{{number}} Month(s)',
    billTypeM12: 'Year',
    nextPeriod: 'Next Period',
    remainingTotal: 'Amount Remaining',
    editBill: 'Edit Bill',
    cancelBill: 'Cancel Bill',
    cancelScheduleBill: 'Cancel Scheduled Bill',
    periodDate: 'Due',
    period: 'Round',
    billNoActive:
      'This bill cannot be requested yet because there is still an incomplete bill.',
    paymentTransBottom: {
      amount: 'Amount',
      baht: 'Baht',
    },
    notTheOwner: '<b>Sorry! This bill is not yours.</b><br/>Unable to Cancel',
    repeatTimeText1: 'Never Ends',
    repeatTimeText2: 'Repeat {{number}} Time(s)',
    durationText1: 'Every {{time}}',
    durationText2: 'Every {{number}} {{time}}',
    month: 'Month(s)',
    week: 'Week(s)',
    expireText: 'Expires',
    completeText: 'Ends',
  },
  scheduleTimeSettingPage: {
    billName: 'Insert Title',
    scheduleDate: 'Start Date',
    scheduleTime: 'Reminder Time',
    remark:
      'Remark: If a month does not have the selected date (eg. 29,30,31) KhunThong will send a reminder at the end of that month instead.',
    remarkEndDate: ' Last Round',
    minDateMessage: 'Scheduled date must start after today’s date.',
    maxDateMessage: 'Starting date should not exceed 1 year.',
    invalidDateMessage: 'Invalid Starting Date',
    repeatTimeSelectListTitle: 'Ends',
    durationUnit: 'Billing every {{number}} {{time}}',
    durationSelectListTitle: 'Repeat Every',
    month: 'month(s)',
    week: 'week(s)',
    now: 'Now',
  },
  repeatTimeSelectList: {
    repeatTimeNoUnit: 'Never-ending',
    repeatTimeUnit: 'Billing {{number}} Time(s)',
  },
  durationSelectList: {
    monthUnit: '{{number}} {{time}}',
    month: 'month(s)',
    week: 'week(s)',
  },
  iframeToKplus: {
    goingToKplus: 'Going to K PLUS',
  },
  imagePage: {
    slogan: 'KhunThong - Chatbot Treasurer, an expert in requesting money',
  },
  imageHero: {
    groupHost: 'Top Requester',
    createBill: 'Created Bill',
    times: 'Times',
  },
  billFlex: {
    paidMemberTitle: 'Paid',
    unpaidMemberTitle: 'Unpaid',
    verifyPaidWithCashTitle: 'Waiting to Verify',
    detailBtn: 'See Details',
    owner: 'Requested by',
    followButton: 'Remind Group',
    deleteButton: 'Cancel Request',
    deleteButton2: 'Delete',
    schedulePeriod: 'Round',
    scheduleDeleteAll: 'Delete all scheduled bills',
    scheduleDelete: 'Delete this month only',
    rogerThat: 'Confirm',
    remindPopup: '<b>Reminder sent :)</b>',
    moreMember: 'and {{numberMember}} more...',
    numberMember: '({{numberMember}} friends)',
    cannotRemindBill: "Sorry! reminder can't be sent.",
    deleteStatusNewDetail: 'This bill is incomplete.',
  },
  billSummary: {
    billWaitingTab: 'Unpaid Bills',
    allBillTab: 'All Bills',
    myBill: 'My Request',
    friendBill: "Other's Request",
    noBill: 'Payment Complete',
    loadingCrop: `Loading~`,
    loadingAction: `Loading~`,
    scheduleBill: 'Your Schedule Plan',
  },
  InviteMoreFriendPage: {
    header: 'Add Outside Members',
    placeholderInputFriend: "Friend's Name",
    headerParentName: 'Came with whom?',
    //parentName: "Friend's Name",
    cameWith: 'Came with',
    comeWith: ' (@{{name}})',
  },
  statusNewVerifyFlex: {
    noUse: 'Delete',
    continueCreateBill: 'Continue',
    finalizeBill: 'Split Bill',
    assignYourself: 'Continue',
    checkYourself: 'Recheck',
    addAccountNo: 'Add Account',
    allSelectedList: 'All items are selected.',
    readyToSummaryBill: 'Your bill is ready to split!',
    noAccountNo: "Recipient's account is missing!",
    noSelectList: 'Please select your items to split bill.',
  },
  paidByCashWaitingFlex: {
    waitingPaidWithCash: 'Waiting to Verify: Marked as Paid',
  },
  autoDeleteFlex: {
    outstandingBill: `Bill is Expiring... This bill has been left unpaid. To extend the reminder please press "Still using". Otherwise, the bill will be automatically cancel within {{dayUntilAutoCancel}} days.`,
    stillUse: 'Still using',
    deleteNow: 'Delete now',
  },
  paymentFlex: {
    pay: 'Payment',
    total: 'Total',
    confirmPay: 'Confirm Payment',
  },
  paymentBySlipPage: {
    header: 'Which bill do you want to pay?',
    headerLabel: 'Transfer Amount on e-Slip:',
    pleaseTellMe: "Your QR on e-slip doesn't provide information",
    pleaseTellMe2: 'please select the bill you transfered to.',
    confirmSlipErrorType: {
      notOwner: '<b>Sorry! Unable to proceed</b><br/> This bill is not yours.',
      slipConfirmed:
        '<b>Sorry! Unable to proceed</b><br/> This bill has been paid.',
      notFound:
        "<b>Sorry! Unable to proceed</b><br/> It's look like this transaction has done.",
    },
  },
  tablet: {
    notSupportTablet: `KhunThong currently doesn't support the Tablet. Please continue this service with your mobile phone.`,
  },
  cancelInfo: {
    cancelBillTitle: 'Select Bill to Delete',
    cancelBillInfo: '',
    noBill: "You don't have a bill.",
  },
  confrimPaidBySlipFlex: {
    waitingForVerify: 'Waiting to Verify: Amount on e-Slip',
    waitingForVerifyAcc: 'Waiting to Verify: Receiving Acc.',
    SentwaitingForVerify: 'has paid ฿ {{total}}',
    SentwaitingForVerifyOwner:
      'has paid ฿ {{total}}. Please check the e-slip before clicking Verify.',
    SentwaitingForVerifyAcc: 'transfered to other account',
    SentwaitingForVerifyAccOwner:
      'transfered to other account, is this one of your account?',
    watchSlip: 'e-Slip',
    listOfWaitingForConfrim: 'Pay for',
    total: 'Total',
    totalSlip: 'Transfer Amount:',
    confrimQuest: 'Have you received and verified this transaction?',
    notGetMoneyQuest: 'Do you want to reject the payment?',
    yesAlreadyGotMoney: 'Yes, I have',
    //close: 'Close',
    remindPopupUnselected: '<span>Please select the bill to pay</span>',
    remindPopupSelected:
      '<b>Please select more bill to pay</b><br/><span>Remaining transfer amount is ฿{{amount}}.</span>',
    rogerThat: 'Got it!',
    rejectPopupTypeError1: 'Verification rejected',
    rejectPopupTypeError2: 'Verification rejected',
    confirmPopup: 'Do you want to confirm?',
  },
  pdpaPage: {
    nextBtn: 'Confirm',
    pdpaHeader1: 'ความยินยอมให้ธนาคารพัฒนาผลิตภัณฑ์หรือบริการให้ดียิ่งขึ้น',
    pdpaHeader2: 'ความยินยอมให้ธนาคารนำเสนอผลิตภัณฑ์หรือบริการ',
    pdpaHeader3:
      'ความยินยอมให้กลุ่มธุรกิจทางการเงิน และพันธมิตร ทางธุรกิจนำเสนอผลิตภัณฑ์หรือบริการ',
    acceptedAllButton: 'ยินยอมทั้งหมด',
    manualAllButton: 'กำหนดเอง',
  },
  transferSlipPage: {
    selectOtherImage: 'Select another',
    confirmButton: 'Confirm',
    popupNoQRCode:
      '<b>QR Code is not found!</b><br/><span>Please send e-Slip with QR Code or contact bill requester</span>',
    popupOldSlip:
      '<b>e-Slip is too old!</b><br/><span>The transaction must be after the request</span>',
    popupDuplicate:
      '<b>e-Slip is duplicate!</b><br/><span>This e-slip has been used</span>',
    popupError:
      '<b>Oops!</b><br/><span>Please send transfer e-Slip with QR or pay with other method</span>',
    popupNotEnoughAmount:
      '<b>Oops!</b><br/><span>Please send transfer e-Slip with QR to the chatroom</span>',
    popupBillCancel:
      '<b>The request has been canceled</b><br/><span>Please check the bill detail</span>',
    popupBillPaid:
      '<b>Hmm! you have paid</b><br/><span>Please check the bill detail</span>',
    tryAgain: 'Retry',
    close: 'OK',
    confirm: 'Got it!',
  },
  HowToPage: {
    header: {
      left: 'Basic',
      right: 'Instructions',
    },
    step1: {
      stepName: '1) Add KhunThong',
      stepDesc:
        "By Adding my LINE ID: @KhunThong or Adding me from the group chat I'm currently part of.",
    },
    step2: {
      stepName: '2) Invite KhunThong into Group',
      stepDesc:
        'Just press Invite from LINE group chat you want me in, and select "KhunThong (ขุนทอง)" from your friend list.',
      bodyStep: {
        step1: 'Select Invite',
        step2: 'Select KhunThong',
      },
      footerStep: {
        text1: 'KhunThong OA must be',
        text2: 'Black Shield Icon',
      },
    },
    step3: {
      stepName: '3) Create Bill',
      stepDesc:
        ' Simply type "KhunThong" into LINE group chat and select "Request". After that select members who shared the bill, insert amount, insert receiving account and lastly, send request into the group chat.',
    },
    step4: {
      stepName: '4) Making Payment',
      stepDesc:
        'If someone created a bill, I will send in the summarized bill into the group chat and everyone will be able to select "Pay" and choose their preferred payment method. If someone made a payment, I will double check to see if the payment is correctly completed. You can also select "See Who Paid" to view those who still owe you.',
    },
    step5: {
      stepName: '5) Remind',
      stepDesc:
        'If someone forgets to pay back, KhunThong will send a reminding message into the group chat at 10am everyday, until everyone completes the payment.',
    },
  },
  FAQPage: {
    header: {
      title: '[Frequently Asked Questions]',
    },
    step1: {
      stepName: '1) How is KhunThong related to KBank?',
      stepDesc:
        'Chatbot Treasurer, an expert in requesting money from Kasikorn Bank. This is to make sharing expenses with LINE group members incredibly easy and less stressful. No matter which bank accounts you use, everyone can Request to Pay conveniently and instantly.',
    },
    step2: {
      stepName: '2) Does KhunThong read chats?',
      stepDesc:
        'KhunThong does not collect any information from chat conversations. KhunThong will only acknowledge information related to the service such as specific keyword commands like "Collect" or any messages mentioning "KhunThong".',
    },
    step3: {
      stepName: '3) Unable to invite KhunThong into the group, Status: Pending',
      stepDesc:
        'LINE only allows 1 LINE Official Account per 1 group, making the second LINE Official Account unable to enter the group',
    },
    step4: {
      stepName:
        '4) What to do if not all members of the group is shown when creating bill',
      stepDesc:
        'Press the refresh button on the right-hand corner of the screen on the page where you select members',
    },
    step5: {
      stepName: '5) Removing KhunThong from the groupchat',
      stepDesc: 'Type #leavegroup',
    },
    step6: {
      stepName: '6) How to recognize a fake KhunThong account?',
      stepDesc1: 'The real KhunThong is an official account. There is a',
      stepDesc2:
        'Black Shield on the profile page, with the LINE ID "@KhunThong" shown. If the real KhunThong is in the groupchat, you will be able to call "KhunThong" and KhunThong will always be available to help handle all transactions!',
    },
  },
  PDPAPage: {
    Approve: 'ยินยอม',
    Unapprove: 'ไม่ยินยอม',
    PDPA: 'การจัดการข้อมูลส่วนบุคคล',
  },
  redeemLocationCodePage: {
    headerText0: '#กรอกโค้ด',
    headerText1: 'แลกรางวัล',
    description: 'กรอกโค้ดโปรโมชั่น',
    button: 'รับสิทธิ์',
    remindText:
      'กรุณาอนุญาตการเข้าถึงตำแหน่งที่ตั้ง เพื่อตรวจสอบเงื่อนไขการได้รับรางวัล',
    placeHolder: 'Referal Code / Promo code',
    errorText: {
      locationDenied: 'กรุณาอนุญาตการเข้าถึงตำแหน่ง',
      invalidCode: 'ขออภัยโค้ดไม่ถูกต้อง โปรดตรวจสอบอีกครั้ง',
      tooFar: 'การรับสิทธิ์ต้องอยู่บริเวณร้าน',
      fullyRedeemed: 'วันนี้คูปองหมดแล้ว',
      alreadyRedeemed: 'คุณพี่ได้ใช้สิทธิ์ไปแล้วค้าบบ',
      unknownError: 'มีข้อผิดพลาด รบกวนคุณพี่ลองใหม่อีกครั้งครับ',
    },
    errorPopup: {
      locationDenied: {
        text: '<b>กรุณาอนุญาตการเข้าถึงตำแหน่ง</b><br />แอป LINE ผ่านเมนูตั้งค่า เพื่อการรับสิทธิ์',
        buttonOk: 'ตกลง',
      },
      tooFar: {
        text: '<b>การรับสิทธิ์ต้องอยู่บริเวณร้าน</b><br />เข้าใกล้ร้านกว่านี้อีกนิดแล้วกดใหม่นะค้าบบ',
        buttonBack: 'ย้อนกลับ',
        buttonMap: 'ดูแผนที่',
      },
    },
  },
  NotKhunthongFriendPage: {
    addFriendKhunthong: 'Add Friend @KhunThong',
    pleaseAddFriendKhunthong: 'กรุณาเพิ่มขุนทองเป็นเพื่อน',
    beforeUse: 'ก่อนเริ่มใช้งาน',
    startToUseKhunthong: 'เริ่มต้นใช้งานขุนทอง',
  },
  WarmWelcomPage: {
    addFriendKhunthong: 'เริ่มต้นใช้งานขุนทอง',
    backToChatAndCreateBill: 'กลับไปสร้างบิลในแชท',
    inviteFriend: 'ชวนเพื่อนรับสูงสุด {{cashbackLimit}} บาท',
    whoIsKhunthong: 'ขุนทองคือใคร?',
    introduceKhunthong: `แชทบอทเหรัญญิกประจำกรุ๊ปไลน์ จากธนาคาร กสิกรไทย
    ที่จะมาช่วยคำนวณค่าใช้จ่ายและเรียกเก็บเงิน จะไปเที่ยวไหนทำอะไร
    ก็แชร์ได้แฟร์ๆ สะดวกทั้งผู้จ่าย และผู้เรียกเก็บเงิน
    ไม่ว่าจะใช้ธนาคารไหนก็ใช้ได้`,
    invite: 'Invite เข้าใน',
    groupLine: 'กรุ๊ปไลน์',
    createBill1: 'มื้อนี้บิลออกมา 1,256 บาท แค่พิมพ์',
    createBill2: ' “ขุนทอง” ',
    createBill3: 'ในกรุ๊ปแล้วเลือก “สร้างบิล”',
    assignTotal: 'ใส่ยอดรวมบิล',
    editAmount: 'แก้ยอดแต่ละคนได้ด้วยนะ',
    pay: 'จ่ายได้ทุกธนาคาร',
    sendBill: `ขุนทองจะส่งสรุปบิลเข้ามาในแชทกลุ่ม
    ทุกคนสามารถกด “จ่ายเงิน” ได้ทันที แล้วเลือก
    วิธีการจ่ายเงินที่ต้องการได้เลย`,
    specialActivity: 'กิจกรรมพิเศษ!',
  },
  startRegisterPage: {
    startKTH: 'เริ่มใช้ขุนทอง',
    subTitleKTH: 'แชทบอทเหรัญญิกประจำกรุ๊ปไลน์',
    inviteKTH: 'Invite “ขุนทอง”',
    toGroupLine: 'เข้ามาใน “กรุ๊ปไลน์” ก่อน',
    addFriendKhunthong: 'เริ่มใช้งานขุนทอง',
    inviteFriend: 'ชวนเพื่อนรับสูงสุด {{cashbackLimit}} บาท',
    whoIsKhunthong: 'ขุนทองคือใคร?',
    introduceKhunthong: `แชทบอทเหรัญญิกประจำกรุ๊ปไลน์ จากธนาคาร กสิกรไทย
    ที่จะมาช่วยคำนวณค่าใช้จ่ายและเรียกเก็บเงิน จะไปเที่ยวไหนทำอะไร
    ก็แชร์ได้แฟร์ๆ สะดวกทั้งผู้จ่าย และผู้เรียกเก็บเงิน
    ไม่ว่าจะใช้ธนาคารไหนก็ใช้ได้`,
    invite: 'พิมพ์ “ขุนทอง” ในกรุ๊ปไลน์',
    groupLine: 'เพื่อเรียกมาช่วยเก็บเงิน',
    createBill1: 'มื้อนี้บิลออกมา 1,256 บาท แค่พิมพ์',
    createBill2: ' “ขุนทอง” ',
    createBill3: 'ในกรุ๊ปแล้วเลือก “สร้างบิล”',
    assignTotal: 'ใส่ยอดรวมบิล',
    editAmount: 'ขุนทองหารให้ ปรับยอดได้ด้วยนะ',
    pay: 'บิลพร้อมจ่ายแล้ว',
    sendBill1: 'รอเพื่อนๆ มากด “จ่ายเงิน”',
    sendBill2: 'เลือกวิธีการจ่ายเงินที่ต้องการ ได้เลย',
    specialActivity: 'กิจกรรมพิเศษ!',
    firstAddAccount: 'ตั้งค่าบัญชีรับเงินครั้งแรก',
    saveAccount1: 'บันทึกเลขบัญชีสำหรับรับหรือจ่ายเงิน',
    saveAccount2: 'ขุนทองเรียกเก็บให้ ใช้ได้ทุกธนาคารนะ',
    plusAddAccount: 'ตั้งค่าบัญชีรับ-จ่าย',
    remind1: '“ลืมจ่าย” ก็เตือนให้',
    remind2: 'ช่วยเตือนทุกวัน จนกว่าเพื่อนจะจ่าย',
    otherBill1: 'บิลแบบอื่น น้องก็เก็บได้~',
    otherBill2: 'บิลรายเดือน',
    otherBill3: 'เรียกเก็บเงินแบบส่วนตัว',
  },
  referreeError: {
    pleaseAddKhunthong: 'กรุณาเพิ่มขุนทองเป็นเพื่อนก่อน',
    referrerDataNotFound: 'เกิดข้อผิดพลาด ไม่พบข้อมูลของผู้เชิญ',
    alreadyKhunthongFriend:
      'พี่เคยเป็นเพื่อนกับขุนทองทองแล้วครับ ชวนเพื่อนคนอื่นต่อได้เลย!',
  },
  referral: {
    instructionPage: {
      activityDuration: 'ช่วงเวลากิจกรรม',
      conditionTitle: 'เงื่อนไขการร่วมสนุก',
      registerKhunThongTitle:
        '<b>ผูกบัญชีกับบริการขุนทอง</b><br/>เพื่อเริ่มชวนเพื่อนและใช้งานขุนทอง',
      registerKhunThongConfirm: 'ผูกบัญชีกับขุนทอง',
      registerKhunThongBack: 'ย้อนกลับ',
      backChatBtn: 'กลับสู่ Chat',
      newActivitySoon: 'พบกิจกรรมใหม่ได้เร็วๆนี้นะค้าบบ~',
      newCampaignSoon: 'แคมเปญจะกลับมาใหม่เร็ว ๆ นี้',
      campaignEnded: 'สิ้นสุดแคมเปญ',
      bindAccountUsingKplus: 'ผูกบัญชีกสิกรไทยผ่าน K PLUS',
      termAndConditionTitle: 'รายละเอียดและเงื่อนไขกิจกรรม',
    },
    termAndCondition: {
      title: 'เงื่อนไขการร่วมกิจกรรม',
    },
    sharePreviewPage: {
      description: 'ตัวอย่างข้อความที่จะแชร์ให้เพื่อน',
      shareFriend: 'แชร์ให้เพื่อน',
    },
    successPage: {
      invited: 'ส่งคำเชิญเรียบร้อยแล้ว',
      description:
        'รอเพื่อนของพี่ มากดเพิ่มขุนทองเป็นเพื่อน\nแล้วอย่าลืมเข้ามาดูยอดเงิน Cashback ของพี่นะ',
    },
    referralCard: {
      yourCashback: 'ยอด Cashback ของคุณ',
      //target: 'บอกว่าจ่ายแล้ว {{price}} บาท',
      remainingDay: 'เหลืออีก {{day}} วัน',
      startToInviteYourFriend: 'เริ่มชวนเพื่อนเลย',
      inviteMoreFriend: 'ชวนเพื่อนเพิ่ม',
      cashbackPrice: '{{price}} บาท',
      target: 'เป้าหมาย {{price}} บาท',
      addBankAccout: '+ เพิ่มบัญชีรับเงิน',
      cashbackAccount: 'บัญชีรับเงินรางวัล:',
      accountNumber: 'เลขบัญชี: {{number}}',
      gotMoneyTitle: 'ขุนทองโอนเงินรางวัลจากกิจกรรม สำเร็จ!',
      txnDate: 'วันที่ทำรายการ',
      topOfTheSocialist: 'สุดยอดแห่งสายโซเชียล',
      youHaveCompleteReferred:
        'ขอบคุณที่ชวนเพื่อนมารู้จักขุนทองครบ {{limit}} คนแล้ว!',
      activityEnded: 'กิจกรรมจบแล้ว',
      thanksForParticipation: 'ขอบคุณที่มาร่วมสนุกกับขุนทองครับบ~',
      outOfQuota: 'เนื่องจากมีผู้ใช้สิทธิ์เต็มจำนวนโอกาสหน้าเจอกันใหม่ค้าบ~',
      yourRewardAmount: 'ยอดเงินรางวัลของคุณ',
    },
  },
  createBillTemplate: {
    whichBillToCreate: 'Select bill template',
    splitByAmount: 'Bill Splitting',
    letMeHelpAmountOfWhom: 'Automatic calculation (Editable)',
    takeReceiptPicture: 'Capture your bill',
    letMeHelpYouRead: 'The price will be filled.',
    fillYourAmountManually: 'Split by Items',
    splitItemsLikeAnExcel: 'Fill-in the list and price',
    monthlyBill: 'Scheduled Bill',
    makeAScheduleNoMoreForget:
      'Set schedule in your group for money collection',
    otherBills: 'Other Schedules',
    seeScheduleBill: 'Check Schedule',
  },
  tutorialTemplate: {
    howToUse: 'วิธีใช้งาน',
    basicUsage: 'การใช้งานเบื้องต้น',
    faq: 'คำถามที่พบบ่อย',
    shortcut: 'คีย์ลัดและเมนูเพิ่มเติม',
  },
  shortkeyPage: {
    header: {
      left: 'คีย์ลัด',
      right: 'และเมนูเพิ่มเติม',
    },
    kthTitle: 'ขุนทอง',
    kthDetail:
      'เรียกขุนทองเพื่อใช้งานในกลุ่ม หรือ ห้องสนทนาที่มีขุนทองอยู่…อย่าลืมเชิญขุนทองเข้ากลุ่มก่อนใช้งานน้าา~',
    requestMoney: '#เก็บเงิน',
    requestMoneyDetail:
      'คำสั่งลัดในการสร้างบิล โดยมี 2 แบบคือ 1.ให้หารให้ด้วย เช่น “#เก็บเงิน ค่าข้าวเที่ยง ทั้งหมด 100 บาท @ชื่อเพื่อน1 @ชื่อเพื่อน2” หรือ 2. เก็บยอดแต่ละคน เช่น “#เก็บเงิน ค่าข้าวเที่ยง คนละ 100 บาท @ชื่อเพื่อน1 @ชื่อเพื่อน2”',
    schedule: '#เก็บรายเดือน',
    scheduleDetail:
      'คำสั่งลัดในการตั้งบิลเรียกเก็บล่วงหน้าแบบรายเดือน หรือ รายสัปดาห์ เหมาะกับการหารค่า Family Plan ต่างๆ ไม่ว่าจะเป็น Netflix, Youtube, Spotify หรือจะเป็น ค่าเช่า, เงินกลุ่ม, เก็บเงินเพื่อผ่อนซื้อของ ก็ทำได้ง่าย',
    multipleBill: '#เปิดโหมดหลายบิล',
    multipleBillDetail:
      'คำสั่งในการเปิดโหมดหลายบิลให้กลุ่มของคุณพี่สร้างบิลได้อย่างจุใจ รองรับการสร้างบิลแบบหลายบิล',
    currency: '#ค่าเงิน',
    currencyDetail:
      'ดูอัตราค่าแลกเปลี่ยนเงินต่างประเทศได้จาก Rate ของบัตรเดบิต Journey ถ้าพี่จะคิดเงินเพื่อนๆ ตอนไปเที่ยวต่างประเทศลองใช้ดูนะครับ',
    medal: '#เหรียญรางวัล',
    medalDetail:
      'สรุปลำดับเหรียญรางวัล และมงกุฎ ของทุกคนในกลุ่ม LINE นั้นครับ เอาไว้ขิงเพื่อนว่าพี่นี้สายโอนไว',
    leave: '#ขุนทองออกไป',
    leaveDetail: 'คำสั่งในการเชิญน้องออกจากกลุ่ม LINE ของพี่ๆครับ',
    delete: '#deleteaccount',
    deleteDetail:
      'ลบข้อมูลบัญชีขารับเงิน โดยให้พี่ๆ พิมพ์ในแชทส่วนตัวกับขุนทองครับ',
    footer:
      'ถ้าพี่เหงาหรือไม่มีคนคุยด้วย พี่มาคุยเล่นกับน้องได้ทุกเรื่องเลยนะ ไม่ว่าจะถามน้องว่า “ขุนทองกินไหนดี”, จะให้น้องชมพี่หรือเพื่อนพี่ “ขุนทองชม...” ก็ได้นะครับ',
  },
  inviteKTHPage: {
    inviteKTH: 'Invite “ขุนทอง”',
    inviteKTH2: 'เข้าในกรุ๊ปไลน์ก่อน',
    click: 'กด',
    inLineGroup: 'ใน LINE กลุ่ม',
    selectInvite: 'เลือก Invite',
    typeKTH: 'พิมพ์ “ขุนทอง” เลย!',
    realKTH: 'ขุนทองตัวจริงต้องมี',
    blackShield: 'โล่ดำด้วยนะ~',
  },
  billCenterPage: {
    request: 'เรียกเก็บเงิน',
    inGroup: 'ในกรุ๊ปไลน์',
    sendPrivate: 'ส่งบิลส่วนตัว',
    sendPrivateChat: 'ส่งบิลใน Chat ส่วนตัว',
    createNew: 'สร้างบิลใหม่',
    privateBillHistory: 'ประวัติบิลเรียกเก็บส่วนตัว',
    tryOne: 'ลองใช้เลย',
    groupHistoyr: 'ประวัติบิลกลุ่ม',
    waitForPay: 'รอจ่าย {{number}} คน',
    noBill: 'บิลที่พี่สร้างไว้จะแสดงที่นี่ค้าบ~~',
    complete: 'เก็บครบแล้ว',
    waitForPayBill: 'บิลที่รอจ่าย',
    completeBill: 'ประวัติบิลที่ปิดแล้ว',
    cretedDate: 'วันที่ {{date}}',
    billInGroup: 'ในกลุ่ม {{name}}',
    perEach: '{{members}} คน / คนละ ฿{{amount}}',
    waitForYouPayBill: 'บิลรอคุณจ่าย',
    waitPay: 'รอจ่าย',
    new: 'ใหม่',
    waitForVerify: 'รอตรวจสอบ',
    billCenterTitle: 'รวมบิลของฉัน~',
    inPrivate: 'แชทส่วนตัว',
    requestInGroup: 'เรียกเก็บเงินในกลุ่ม',
    requestInPrivate: 'เรียกเก็บในแชทส่วนตัว',
    createBill: 'สร้างบิล',
    billWaitForPay: 'บิลที่รอพี่มาจ่าย',
    billYouCreate: 'บิลที่พี่สร้างไว้',
    requestBy: 'เรียกเก็บโดย {{name}}',
  },
  createPrivateBillPage: {
    createBill: 'สร้างบิลเรียกเก็บ',
    inputBillName: 'ใส่ชื่อบิล',
    payIn: 'บิลหมดอายุ:',
    includeMe: 'หารฉันด้วย',
    notIncludeMe: 'ฉันไม่ได้อยู่ในบิลนี้',
    totalMember: 'หาร {{number}} คน',
    requestPer: 'เรียกเก็บคนละ ฿{{number}}',
    requestOne: 'เรียกเก็บ ฿{{number}}',
    requestTotal: 'ยอดเรียกเก็บ',
    requestSummary: 'ยอดรวมบิล',
    requestOneTab: 'เรียกเก็บคนเดียว',
    requestManyTab: 'เรียกเก็บหลายคน',
  },
  previewPrivateBillPage: {
    shareToFriends: 'ส่งบิลเรียกเก็บ {{number}} คน',
    tooManyBills: 'คุณพี่สร้างบิลได้แค่ {{number}} บิล \nเท่านั้นคร้าบบ~',
    reachAmountLimit:
      'คุณพี่สร้างบิลได้ไม่เกินวันละ {{number}} บาท \nเท่านั้นคร้าบบ~',
    reachLimitAmountPerBill:
      'คุณพี่สร้างบิลได้ไม่เกิน {{number}} บาท \nเท่านั้นคร้าบบ~',
    notePlaceholder: 'ใส่โน๊ตสั้นๆ ถึงเพื่อน',
    noteExceedLimit:
      'ขออภัยค้าบ ขุนทองรองรับข้อความได้สูงสุดไม่เกิน {{number}} ตัวอักษรน้า',
    //Sorry! Please shorten your memo (Limit {{number}} characters).
    payBill: 'จ่ายเงิน',
    summaryBill: 'สรุปบิลเรียกเก็บ',
  },
  privateBillSummaryPage: {
    sendAgain: 'ส่งบิลอีกครั้ง',
    waitFriendResponse: 'รอเพื่อนตอบรับ {{number}} คน',
    remove: 'ลบออก',
    editBill: 'แก้ไขบิล',
    complete: 'เสร็จสิ้น',
    waitForResponse: 'รอเพื่อนตอบรับ',
    billWillExpire: 'บิลนี้กำลังจะหมดอายุ',
    expireRetry: 'พี่สามารถส่งบิลอีกครั้ง หรือลบได้เลยหากไม่ใช้',
  },
  groupListPage: {
    allGroup: 'เลือกกรุ๊ปไลน์',
    searchGroup: 'ค้นหากรุ๊ปไลน์',
    subTitle: 'ให้น้องช่วยเก็บเงินที่กรุ๊ปไหนดีค๊าบ~',
    noBillText1: 'ถ้าไม่มีกรุ๊ปที่พี่ต้องการ',
    noBillText2: 'ช่วยเพิ่ม “ขุนทอง” เข้ากรุ๊ปก่อนนะค๊าบ~',
  },
  previewCreateBillPage: {
    shareToGroup: 'ส่งบิลเข้ากลุ่ม',
    seeWhoPaid: 'ดูว่าใครจ่ายเงินแล้ว',
    durationDate: 'วันที่ {{day}}, {{time}}',
    weekDate: 'วัน{{day}}, {{time}}',
  },
  privateBillPaymentSuccessPage: {
    payFor: 'ให้คุณ <span>@{{ownerName}}</span> {{backWord}}',
    complete: 'เรียบร้อย',
    amount: 'จำนวน',
    paidWithCashTitle: 'จ่ายแล้วด้วยเงินสด',
    paidWithCashWaitingTitle: 'รอตรวจสอบจากผู้รับเงิน',
    paidWithSlipTitle: 'จ่ายแล้วยืนยันหลักฐานด้วยสลิป',
    overAmountTitle: 'จ่ายแล้วด้วยสลิป แต่พี่โอนมาเกินนะ',
    underAmountTitle: 'โอนมาไม่ตรงกับยอดที่เรียกเก็บ',
    paidWithSlipErrorType1Title: 'รอผู้รับเงินตรวจสอบสลิป',
    paidWithSlipErrorType2Title: 'โอนมาไม่ตรงกับบัญชีที่เรียกเก็บ',
    overAmount: 'โอนเกินมา',
    underAmount: 'เหลือต้องจ่ายอีก',
    bill: 'บิล',
    withSlip: 'ด้วยสลิป',
    transferAmount: 'จำนวนเงินที่โอนมา',
  },
  deepLinkCreateBill: {
    createNewBill: 'อยากส่งบิลแบบไหน~',
    enterFrom: 'จากช่องทาง',
    enterAmount: 'จำนวนเงิน',
    createGroupBillTitle: 'ส่งในกลุ่มไลน์',
    createGroupBillSubTitle: 'เรียกเก็บเพื่อนในกรุ๊ปไลน์ทางนี้เลย',
    createPrivateBillTitle: 'ส่งแยกในแชทส่วนตัว',
    createPrivateBillSubTitle: 'หารและส่งบิลให้เพื่อนในแชทได้เลย',
    summaryBill: 'สรุปบิล',
  },
  scheduleCarousel: {
    createDate: 'Next Bill:',
    lastBill: 'Requesting',
    everyDay: 'Every',
    everyMonthDay: 'Every {{month}} months on',
    everyWeek: 'Every week on {{day}}',
    every2Week: 'Every 2 weeks on {{day}}',
  },
};

export default langEn;
